// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";

// 生产环境注释掉对element-ui css文件的引用，否则会打进包里
// import "element-ui/lib/theme-chalk/index.css";
import ELEMENT from "element-ui";
import "./assets/global.css";

Vue.config.productionTip = false;
Vue.use(ELEMENT);

// 项目初始化时，进行数据存储
const login = JSON.parse(localStorage.getItem("login"));
const token = localStorage.getItem("token");
// 从localStorage中存储到vuex
store.dispatch("setLogin", login);
store.dispatch("setToken", token);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js